const Button = ({
  children,
  size = 'md',
  variant = 'primary',
  className = '',
  ...props
}) => {
  const baseStyles = 'font-semibold font-opensans rounded-[44px] transition duration-300 cursor-pointer inline-flex items-center justify-center gap-2';

  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-6 text-base'
  };

  const variantStyles = {
    primary: 'text-black hover:text-white',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-Neautral-main'
  };

  const sizeClass = sizeStyles[size] || sizeStyles.md;
  const variantClass = variantStyles[variant] || variantStyles.primary;

  const getButtonStyle = () => {
    if (variant === 'primary') {
      return {
        backgroundColor: '#a8d5a8',
      };
    }
    return {};
  };

  const getHoverStyle = () => {
    if (variant === 'primary') {
      return '#92c792';
    }
    return null;
  };

  return (
    <button
      className={`${baseStyles} ${sizeClass} ${variantClass} ${className}`}
      style={getButtonStyle()}
      onMouseEnter={(e) => {
        if (variant === 'primary') {
          e.target.style.backgroundColor = getHoverStyle();
        }
      }}
      onMouseLeave={(e) => {
        if (variant === 'primary') {
          e.target.style.backgroundColor = '#a8d5a8';
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
